<div class="action-button-container" [matMenuTriggerFor]="actionsMatMenu">
    <wm-common-button [data]="{text:actionButtonTemplate}"></wm-common-button>
</div>
<ng-template #actionButtonTemplate>
    <div class="action-button">
        <wm-common-text [data]="{text:'ACTIONS'}"></wm-common-text>
        <wm-common-icon [data]="{iconName:dropDownIcon}"></wm-common-icon>
    </div>
</ng-template>
<mat-menu #actionsMatMenu="matMenu" yPosition="below">
    <div class="actions-menu-card">
        <!-- always -->
         @if (canViewVersion) {
          <wm-common-button [data]="onViewApplicationWorkflowClick()"></wm-common-button>
         }
        <!-- completed -->
        @if (statusCode === 2) {
          @if(canEditCompletedApplication === true){
            <wm-common-button [data]="onReCalculateApplicationDescriptionClick()"></wm-common-button>
          }


        @if (canEditApplicationNumber === true) {
          <wm-common-button [data]="onEditApplicationNumberClick()"></wm-common-button>
        }
        }
        <!-- except incomplete or in progress -->
        @if (statusCode !== 1) {
          @if (canReopenApplication === true) {
            <wm-common-button [data]="onReOpenApplicationClick()"></wm-common-button>
          }
        }

        <!-- in progress -->
        @if (statusCode === 1) {
        <wm-common-button [data]="{text:'Void'}" (click)="voidApplication()"></wm-common-button>
        <wm-common-button [data]="{text:'Expire'}" (click)="expireApplication()"></wm-common-button>
        <wm-common-button [data]="{text:'Lock'}" (click)="lockApplication()"></wm-common-button>
        <wm-common-button [data]="{text:'Withdraw'}" (click)="withdrawApplication()"></wm-common-button>
        <wm-common-button [data]="onDiscardApplicationClick()"></wm-common-button>
        }
    </div>
</mat-menu>
<!-- edit application number start -->
<wm-common-confirmation-modal [data]="editApplicationNumberModalData" (onYesClick)="handleEditApplicationNumberModalAccepted()"
    (onNoClick)="handleEditApplicationNumberModalRejected()">

    <div class="edit-application-no-container">
        <wm-common-textfield
          [data]="applicationNumberFieldConfig"
          [(ngModel)]="applicationNumber"
          (ngModelChange)="handleApplicationNumberChange($event)"
        >
        </wm-common-textfield>

        <wm-common-text [data]="{
        text:'WARNING: The number you are editing is the system generated number. The application has not reached the point of generating a number, or it is not configured to generate a specific application number. Changing this value now will override any prefix and incremented number logic that may be generated later on in the lifecycle of this application.'
    }"></wm-common-text>
    @if (editApplicationNumberLoader !== '') {
       <div class="loading-text" >
    <wm-common-text [data]="{
        text:editApplicationNumberLoader
    }"></wm-common-text>
    </div>
    }

    @if (applicationNoAlreadyExist === true) {
<div class="in-use-application-text" >
    <wm-common-text [data]="{
        text:'New application number is already in use by an application.Please try different application number'
    }"></wm-common-text>
    </div>
    }

    </div>

</wm-common-confirmation-modal>
<!-- edit application number end -->
 <!-- re-open application  start -->
<wm-common-confirmation-modal [data]="reOpenApplicationModalData" (onYesClick)="handleReOpenApplicationModalAccepted()"
    (onNoClick)="handleReOpenApplicationModalRejected()">
</wm-common-confirmation-modal>
<!-- re-open application end -->
  <!-- discard application  start -->
<wm-common-confirmation-modal [data]="discardApplicationModalData" (onYesClick)="handleDiscardApplicationModalAccepted()"
    (onNoClick)="handleDiscardApplicationModalRejected()">
</wm-common-confirmation-modal>
<!-- discard application end -->
   <!-- re-calculate application description  start -->
<wm-common-confirmation-modal [data]="recalculateApplicationDescriptionModalData" (onYesClick)="handleReCalculateApplicationDescriptionModalAccepted()"
    (onNoClick)="handleReCalculateApplicationDescriptionModalRejected()">
</wm-common-confirmation-modal>
<!-- re-calculate application description  end -->

<!-- Start By Deepak 2026-03-05  -->
        <wm-modal-confirm
          moduleId="action_application"
          [showButton]="false"
          [title]="ActionApplicationText + ' Application'"
          [commandText]="ActionApplicationText + ' Application'"
          (accepted)="actionWorkflowApplication()"
          [form]="ActionApplicationForm"
          [janusStyling]="templateForPermitForm"
          janusModalWidth="630px"
          #actionApplicationModal

        >
          <div [formGroup]="ActionApplicationForm">
            <div class="row">
              <div class="col">
                <label for="closeReason"
                  >{{ ActionApplicationText }} Reason</label
                >
                <textarea
                  style="height:100px"
                  id="closeReason"
                  name="closeReason"
                  class="form-control mx-2"
                  formControlName="closeReason"
                  [placeholder]="ActionApplicationText + ' Reason'"
                  [attr.aria-label]="ActionApplicationText + ' Reason'"
                >
                </textarea>
                <div *ngIf="closeReason?.untouched" class="text-danger">
                  * {{ ActionApplicationText }} Reason is required.
                </div>
                <div
                  *ngIf="
                    closeReason?.invalid &&
                    (closeReason?.dirty || closeReason?.touched)
                  "
                  class="alert alert-danger"
                >
                  <div
                    *ngIf="closeReason.errors['required']"
                    class="text-danger"
                  >
                    * {{ ActionApplicationText }} Reason is required. *
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="closeDateTime" class="mt-2">
                  Time
                  <input
                    id="closeDateTime"
                    name="closeDateTime"
                    class="form-control mt-2"
                    formControlName="closeDateTime"
                    placeholder=""
                    aria-label="DateTime"
                  />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="mt-2">
                  Changed By
                  <input
                    name="closedBy"
                    class="form-control mt-2"
                    formControlName="closedBy"
                    placeholder=""
                    aria-label="ClosedBy"
                  />
                </label>
              </div>
            </div>
          </div>

          <p>Any inspections currently in progress will be marked as Voided, and will not be visible by default in inspection searches.</p>

          <p>Are you sure you want to {{ ActionApplicationText.toLowerCase() }} this application?</p>
        </wm-modal-confirm>
<!-- End By Deepak 2026-03-05 -->
